import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import {Dropdown} from "primereact/dropdown";
import axios from "axios";

import LocationGeometryListComponent from "./LocationGeometryListComponent";

const LocationFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [types, setTypes] = useState([]);
  const [countries, setCountries] = useState([]);
  const [newFormData, setNewFormData] = useState({});
  const roles = localStorage.getItem('roles')?.toString().toLowerCase() || '';

  const hasRole = (role) => {
    return roles.includes(role.toLowerCase());
  };

  const locationId = window.App.urlVars().locationId ?? id;

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    if ((window.App.urlVars().locationId) || (entity === 'location' && id)) {
      apiCall('patch', '/api/v2/location/' + (window.App.urlVars().locationId ?? id), newFormData)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderLocationList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      apiCall('post', '/api/v2/location', data)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderLocationList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          } else {
            history.push('/settings/location/update/' + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }
  // const toolbarOptions = {
  //   container: [
  //     [{'header': [1, 2, 3, 4, 5, 6, false]}],
  //     ['bold', 'italic', 'underline', 'strike'],
  //     ['image', 'formula'],
  //     [{'align': []}],

  //     [{'list': 'ordered'}, {'list': 'bullet'}, {'list': 'check'}],
  //     [{'script': 'sub'}, {'script': 'super'}],
  //     [{'indent': '-1'}, {'indent': '+1'}],
  //     [{'color': []}, {'background': []}],
  //     ['clean']
  //   ]
  // }

  useEffect(() => {
    if ((!window.App.urlVars().create && window.App.urlVars().locationId) || (entity === 'location' && id)) {
      setLoading(true);
      apiCall('get', '/api/v2/location/' + (window.App.urlVars().locationId ?? id))
        .then(response => {
          setFormData(response.data.data)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
    else {
      setFormData(prev => ({
        ...prev,
        address_country_code: prev.address_country_code ?? process.env.REACT_APP_DEFAULT_COUNTRY
      }))
    }
    apiCall('get', '/api/v2/dictionary/location-type')
      .then(response => {
        setTypes(response.data.data || []);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('get', '/api/v2/country')
      .then(response => {
        const countryOptions = Array.isArray(response.data)
          ? response.data
          : Array.isArray(response.data?.data)
            ? response.data.data
            : [];
        setCountries(countryOptions);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
  }, [])

  return (
    <div className={"location-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-5"}>
              <Field name="name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="name"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldName')}</label>
                  <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-3"}>
              <Field name="type" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="type"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldType')}</label>
                  <span className="p-d-block">
                      <Dropdown id="type" {...input}
                                options={window.App.sortDropdownOptions(types, "value")}
                                optionLabel="value"
                                optionValue="key"
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    type: e.target.value
                                  })
                                   setNewFormData({
                                     ...newFormData,
                                     type: e.target.value
                                   })
                                 }}
                                 value={formData.type}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-2"}>
              <Field name="address_country_code" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="address_country_code"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldAddressCountryCode')}</label>
                  <span className="p-d-block">
                      <Dropdown id="address_country_code" {...input}
                                 options={window.App.sortDropdownOptions(countries, "name")}
                                 optionLabel="name"
                                 optionValue="code"
                                 emptyMessage={t('noCountryYet')}
                                 filter
                                 showClear
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     address_country_code: e.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     address_country_code: e.value
                                   })
                                 }}
                                 value={formData.address_country_code}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-2"}>
              <Field name="address_postal_code" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="address_postal_code"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldAddressPostalCode')}</label>
                  <span className="p-d-block">
                      <InputText id="address_postal_code" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     address_postal_code: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     address_postal_code: e.target.value
                                   })
                                 }}
                                 value={formData.address_postal_code}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="address_city" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="address_city"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldCity')}</label>
                  <span className="p-d-block">
                      <InputText id="address_city" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     address_city: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     address_city: e.target.value
                                   })
                                 }}
                                 value={formData.address_city}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-8"}>
              <Field name="address_detail" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="address_detail"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldAddressDetail')}</label>
                  <span className="p-d-block">
                      <InputText id="address_detail" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     address_detail: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     address_detail: e.target.value
                                   })
                                 }}
                                 value={formData.address_detail}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>


          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'location' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
          
          {locationId && hasRole('role_location_geometry_read') &&
            <LocationGeometryListComponent
              locationId={locationId}
              canWrite={hasRole('role_location_geometry_write')}
              t={t}
            />
          }
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(LocationFormComponent);
